import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Surveyyeppy = () => {
  return (
    <div className="survey_yeppy p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="my-md-auto my-lg-0 my-xl-0 my-xxl-0"
          >
            <h2>Survey Methodology</h2>
            <p>
              We did a survey with 50+ users in combination with different
              questions to know their views, experience, and insights in order
              to get qualitative and quantitative data. Here’s an overview of
              the questions we've asked so far.
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="survey_box">
              <div className="survey_content">
                <h5>
                  When you plan a vacation, which mode of transportation do you
                  prefer?
                </h5>
                <ul>
                  <li>Air travel</li>
                  <li>Road trip (car or bus)</li>
                  <li>Train travel</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="survey_box">
              <div className="survey_content">
                <h5>How do you typically book your travel accommodations?</h5>
                <ul>
                  <li>Hotel websites or apps</li>
                  <li>Online travel agencies (e.g., Expedia)</li>
                  <li>
                    Directly through the property (e.g., calling the hotel)
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="survey_box">
              <div className="survey_content">
                <h5>
                  What features are most important to you when booking travel
                  accommodations?
                </h5>
                <ul>
                  <li>Competitive pricing</li>
                  <li> User reviews and ratings</li>
                  <li>Location and proximity to attractions</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="survey_box">
              <div className="survey_content">
                <h5>
                  When it comes to managing your finances, which tools or
                  services do you currently use?
                </h5>
                <ul>
                  <li>Traditional bank branches</li>
                  <li>Mobile banking apps</li>
                  <li>Online financial management platforms</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="survey_box">
              <div className="survey_content">
                <h5>
                  What are your biggest concerns when it comes to financial
                  services and managing your money?
                </h5>
                <ul>
                  <li>Security and data privacy</li>
                  <li>Accessibility and ease of use</li>
                  <li>Financial advice and planning</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Surveyyeppy;
